module.exports = __webpack_public_path__ + "static/media/ashtonspina.735d5cc8.jpg";